import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
/**
 * The SkipTourLabel Components for Tour Component.
 */
export function SkipTourLabel(props) {
  return (
    <>
      {props.visible ? (
        <span
          className={style.skipLabel}
          onClick={props.onClick}
          role="button"
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              props.onClick;
            }
          }}
        >
          {props.label}
        </span>
      ) : null}
    </>
  );
}

SkipTourLabel.propTypes = {
  /**
   * className to be set for SkipTourLabel element
   */
  className: PropTypes.string,
  /**
   * Text to be displayed
   */
  label: PropTypes.string.isRequired,
  /**
   * Boolean specifying if SkipTourLabel is visible
   */
  visible: PropTypes.bool,
};

SkipTourLabel.defaultProps = {
  className: "",
  label: "Skip tour",
  visible: true,
};
